import React from 'react';
import NewPassComp from '../../components/auth/NewPassComp';

const NewPass = () => {
  return (
    <div>
        <NewPassComp />
    </div>
  )
}

export default NewPass